import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { ActiveMembers, Props as WidgetProps } from './ActiveMembers';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import reduxConnectContainer from './ActiveMembers.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import EmptyState from '../../EmptyState';

import s from './ActiveMembers.scss';

const ActiveMembersConfigPopover = lazy(() =>
  import(/* webpackChunkName: "owner" */ './ActiveMembersConfigPopover')
);
const enhance = compose(reduxConnectContainer);

const ActiveMembersBox: React.FC<WidgetProps &
  WidgetBoxProps & { isEmpty: boolean }> = ({
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  section,
  zone,
  isEmpty,
  ...props
}) => {
  const { t } = useTranslation();
  const { moduleId } = props;

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.activeMembers.header`)}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      widgetMenuRenderer={close => (
        <Suspense fallback={<ChunkLoadingPopover />}>
          <ActiveMembersConfigPopover moduleId={moduleId} onClose={close} />
        </Suspense>
      )}
      isEmpty={isEmpty}
      emptyView={
        <EmptyState
          view="small"
          className={s['empty-state']}
          titleClassName={s['empty-state-title']}
          title={t(`widgets.activeMembers.empty.title.visitor`)}
          subtitle={t(`widgets.activeMembers.empty.subtitle.visitor`)}
        />
      }
    >
      <ActiveMembers {...props} />
    </WidgetBox>
  );
};

export default enhance(ActiveMembersBox);
